import produce from 'immer';
import {
	FETCH_PAGE_PENDING,
	FETCH_PAGE_FULFILLED,
	FETCH_PAGE_FAILED,
	FETCH_INITIAL_PAGE_FULFILLED
} from '../constants/page.actions';

const pageReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case FETCH_PAGE_PENDING: {
				draft.loading = true;
				draft.error404 = false;
				draft.error500 = false;
				break;
			}
			case FETCH_INITIAL_PAGE_FULFILLED: {
				draft.loading = false;
				draft.page = action.payload.page;
				draft.error404 = false;
				draft.error500 = false;
				draft.pages[action.payload.page.Id] = action.payload.page;
				break;
			}
			case FETCH_PAGE_FULFILLED: {
				draft.loading = false;
				draft.page = action.payload.page;
				draft.error404 = false;
				draft.error500 = false;
				draft.pages[action.payload.page.Id] = action.payload.page;
				break;
			}
			case FETCH_PAGE_FAILED: {
				// TODO: Handle no internet specifically?
				draft.loading = false;
				draft.error404 = (action.payload.status >= 400 && action.payload.status < 500);
				draft.error500 = action.payload.status >= 500 || action.payload.status === 0;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		page: null,
		pages: {},
		loading: false,
		error404: false,
		error500: false
	}
);

export default pageReducer;
